// Igbo translations
export const ig: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Ndị ahịa',
  'menu.products': 'Ngwaahịa',
  'menu.users': 'Ndị ọrụ',
  'menu.settings': 'Ntọala',
  'menu.logout': 'Pụọ',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Order Ọhụrụ',
  'order.title': 'Order Ọhụrụ',
  'order.customer': 'Onye ahịa',
  'order.products': 'Ngwaahịa',
  'order.total': 'Ngụkọta',
  'users.title': 'Ndị ọrụ',
  'users.name': 'Aha',
  'users.email': 'Email',
  'common.yes': 'Ee',
  'common.no': 'Mba',
  'common.cancel': 'Kagbuo',
  'common.save': 'Chekwaa',
  'common.search': 'Chọọ',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Banye',
  'login.welcome': 'Nnọọ, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Email',
  'signup.phone': 'Ekwentị',
  'menu.reportsAndAccounting': 'Akụkọ & Ndekọ Ego',
  'menu.systemAndCommunication': 'Sistemụ & Nkwukọrịta',
};